var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendanceLate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 21.1525C15.027 21.1525 19.2727 16.9069 19.2727 11.8803C19.2727 6.85381 15.027 2.6082 10.0005 2.6082C4.97399 2.6082 0.728378 6.85381 0.728378 11.8803C0.728378 16.9069 4.97399 21.1525 10.0005 21.1525ZM10.0005 4.66868C13.9092 4.66868 17.2122 7.97162 17.2122 11.8803C17.2122 15.7891 13.9092 19.092 10.0005 19.092C6.09179 19.092 2.78885 15.7891 2.78885 11.8803C2.78885 7.97162 6.09179 4.66868 10.0005 4.66868ZM15.4443 2.30634L16.899 0.847527L20 3.93824L18.5443 5.39809L15.4443 2.30634ZM3.07938 0.850617L4.54026 2.30531L1.45985 5.39602L0 3.9403L3.07938 0.850617Z",
    fill: "#EEB340"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97028 7.75939H11.0308V12.9106H8.97028V7.75939ZM8.97028 13.9408H11.0308V16.0013H8.97028V13.9408Z",
    fill: "#EEB340"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceLate);
export default __webpack_public_path__ + "static/media/attendance_late.f7818d95b09b586d1d77a230fe00cc2f.svg";
export { ForwardRef as ReactComponent };